<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="fm-title"><a id="page_5">Contents</a></p><a id="page_5">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc"><a href="#/xhtml/06_Preface">Preface</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><a href="#/xhtml/07_Part01"><b>Part One</b></a></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/07_Part01"><b><i>Illustrious</i> Blitz</b></a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><a href="#/xhtml/08_Chapter01">Chapter 1</a></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/08_Chapter01">Stormy Prospects</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><a href="#/xhtml/09_Chapter02">Chapter 2</a></p></td>
<td align="left" valign="top"><p class="toc1"><a href="#/xhtml/09_Chapter02">Heroic Heritage</a></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">Chapter 3</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">Conversation with a Marine</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">Chapter 4</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">Just Dreams?</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">Chapter 5</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">Wardroom Issues</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">Chapter 6</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">Going Wrong</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample">Chapter 7</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample">Trapani, Sicily</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample">Chapter 8</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample">Rising Tension</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample">Chapter 9</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample"><i>Illustriou</i>s Looms</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample">Chapter 10</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample">Stuka Intruder</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample">Chapter 11</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample">Hangar Horrors</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample">Chapter 12</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample">Concussed</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/20_Chapter13" title="Link target outside of Sample">Chapter 13</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/20_Chapter13" title="Link target outside of Sample">Heaven or Hell?</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/21_Chapter14" title="Link target outside of Sample">Chapter 14</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/21_Chapter14" title="Link target outside of Sample">Quarter-Deck Mayhem</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/22_Chapter15" title="Link target outside of Sample">Chapter 15</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/22_Chapter15" title="Link target outside of Sample">Malta Waits</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/23_Chapter16" title="Link target outside of Sample">Chapter 16</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/23_Chapter16" title="Link target outside of Sample">Ongoing Battle</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/24_Chapter17" title="Link target outside of Sample">Chapter 17</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/24_Chapter17" title="Link target outside of Sample">Absent Friends</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><a id="page_6"></a><span href="#/xhtml/25_Part02" title="Link target outside of Sample"><b>Part Two</b></span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/25_Part02" title="Link target outside of Sample"><b>Crete Conflict</b></span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/26_Chapter18" title="Link target outside of Sample">Chapter 18</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/26_Chapter18" title="Link target outside of Sample">Dawn Chorus</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/27_Chapter19" title="Link target outside of Sample">Chapter 19</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/27_Chapter19" title="Link target outside of Sample">Stand To</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/28_Chapter20" title="Link target outside of Sample">Chapter 20</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/28_Chapter20" title="Link target outside of Sample">Call of Duty</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/29_Chapter21" title="Link target outside of Sample">Chapter 21</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/29_Chapter21" title="Link target outside of Sample">Long Legacies</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/30_Chapter22" title="Link target outside of Sample">Chapter 22</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/30_Chapter22" title="Link target outside of Sample">Air Raid</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/31_Chapter23" title="Link target outside of Sample">Chapter 23</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/31_Chapter23" title="Link target outside of Sample">Know Thy Enemy</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/32_Chapter24" title="Link target outside of Sample">Chapter 24</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/32_Chapter24" title="Link target outside of Sample">Invasion</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/33_Chapter25" title="Link target outside of Sample">Chapter 25</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/33_Chapter25" title="Link target outside of Sample">Turning Tide</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/34_Chapter26" title="Link target outside of Sample">Chapter 26</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/34_Chapter26" title="Link target outside of Sample">Withdrawal</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/35_Chapter27" title="Link target outside of Sample">Chapter 27</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/35_Chapter27" title="Link target outside of Sample">Mountain Escape</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/36_Chapter28" title="Link target outside of Sample">Chapter 28</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/36_Chapter28" title="Link target outside of Sample">Shades of Dunkirk</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/37_Chapter29" title="Link target outside of Sample">Chapter 29</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/37_Chapter29" title="Link target outside of Sample">Final Scenes</span></p></td>
</tr>
<tr>
<td align="left" valign="top"><p class="toc"><span href="#/xhtml/38_Chapter30" title="Link target outside of Sample">Chapter 30</span></p></td>
<td align="left" valign="top"><p class="toc1"><span href="#/xhtml/38_Chapter30" title="Link target outside of Sample">Postscript –<br/>A summary of Captain A W F ‘Alfie’ Sutton’s life by Captain Richard Sutton</span></p></td>
</tr>
<tr>
<td align="left" colspan="2" valign="top"><p class="toc"><span href="#/xhtml/39_Index" title="Link target outside of Sample">Index</span></p></td>
</tr>
</tbody>
</table>
</a></div><a id="page_5">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?5d77ea74